import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/App';
import './css/main.scss';

ReactDOM.render(<App />, document.querySelector('#root'));
